import { render } from "./Main.vue?vue&type=template&id=f5d222ca"
const script = {}
script.render = render

export default script